/**
 * Created by Shen Mo on 2021/5/18
 */
import * as _ from 'lodash-es';
import { useCallback, useEffect, useRef } from 'react';

import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { shallowEqual } from '@core/utils';

export const stateShallowEqual = (data, cache) => {
	return shallowEqual(data, cache);
};
// 获取store数据 - 获取整体store
export const useStore = (store) => {
	const getState = useCallback(() => store.getState(), [store]);
	return useSyncExternalStore(store.addChangeListener, getState);
};

// 获取store数据 - 通过selector来转换数据 or 获取单一项目的值
export const useStoreState = (store, selector = null, isEqual = null) => {
	const cached = useRef(null);
	const getSelectorState = useCallback(() => {
		const storeState = store.getState();
		let result = storeState;
		if (_.isFunction(selector)) {
			result = selector(storeState);
		} else if (_.isString(selector)) {
			result = _.get(storeState, selector);
		}
		if (isEqual) {
			if (!cached.current || !isEqual(result, cached.current)) {
				cached.current = result;
			}
			return cached.current;
		}
		return result;
	}, [store, selector, isEqual]);

	return useSyncExternalStore(store.addChangeListener, getSelectorState);
};

// 对于事件回调相关的处理 - 使用场景可能已经不多了，loading相关的变化
export const useStoreCallback = (store, callback) => {
	useEffect(() => {
		let isRendered = true;
		function handleStateChange(action) {
			if (isRendered) {
				callback(action);
			}
		}
		const unbind = store.addChangeListener(handleStateChange);
		return () => {
			isRendered = false;
			unbind();
		};
	}, [callback]);
};
